import Page from './index';
export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/invoices',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/invoices/:id',
			exact: true,
			component: Page.Details
		},
	]
};